export function wait(delayMilliseconds: number): Promise<void> {
  return new Promise(function (resolve) {
    setTimeout(resolve, delayMilliseconds);
  });
}
